module.exports = __webpack_public_path__ + "img/car_sendai03.be124ee1.jpg";